export default "__VITE_ASSET__CxpbeQuT__"